import { render, staticRenderFns } from "./TypePage.vue?vue&type=template&id=5adc2e3e&scoped=true&"
import script from "./TypePage.vue?vue&type=script&lang=js&"
export * from "./TypePage.vue?vue&type=script&lang=js&"
import style0 from "./TypePage.vue?vue&type=style&index=0&id=5adc2e3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc2e3e",
  null
  
)

export default component.exports